import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _Skeleton;
var _excluded = ["sx"];
import React from 'react';
import { Container, Skeleton, extendSX } from '@lumahealthhq/ui-core';

/**
 * This is the Fallback component to render till the module is ready.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export default function FallbackContainerQueueManagerBuilder(props) {
  var sx = props.sx,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_jsx(Container, _extends({
    maxWidth: false,
    disableGutters: true,
    sx: extendSX({
      p: 2,
      display: 'grid',
      height: '100%'
    }, sx)
  }, rest, {
    children: _Skeleton || (_Skeleton = /*#__PURE__*/_jsx(Skeleton, {
      variant: "rounded",
      height: "100%"
    }))
  }));
}